import { LoadableLazy } from '@confluence/loadable';

export const GuestRequestToUpgradeDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GuestRequestToUpgradeLearnMoreModal" */ '../src/guest-request-upgrade/GuestRequestToUpgradeLearnMoreModal.tsx'
			)
		).GuestRequestToUpgradeLearnMoreModal,
});
